import {
  Directive,
  AfterViewInit,
  OnDestroy,
  TemplateRef,
  EmbeddedViewRef,
  ViewContainerRef,
  EventEmitter,
  Output,
  ContentChild
} from "@angular/core";

@Directive({
  selector: "[lazyLoader]",
  host: {},
  exportAs: "lloader"
})
export class LazyLoaderDirective implements AfterViewInit, OnDestroy {
  @Output() onToggle = new EventEmitter();
  @ContentChild(TemplateRef) template: TemplateRef<any>;

  view: EmbeddedViewRef<any>;
  visible: boolean;

  constructor(public viewContainer: ViewContainerRef) {}

  ngAfterViewInit() {
    if (this.visible) {
      this.load();
    }
  }

  load() {
    this.visible = true;
    this.view = this.viewContainer.createEmbeddedView(this.template);
    this.onToggle.emit(true);
  }

  unload() {
    this.visible = false;
    this.viewContainer.clear();
    this.onToggle.emit(false);
  }

  ngOnDestroy() {
    this.view = null;
  }
}
